import { useEffect, useState } from "react";

export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const checkTouchDevice = () => {
      const hasTouchSupport =
        "ontouchstart" in window ||
        (window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
      setIsTouchDevice(hasTouchSupport);
    };

    checkTouchDevice();

    // Add a listener for changes in media query, so state is updated if the pointer type changes
    // while the app is running (e.g. switching between a touchscreen and mouse on a 2-in-1 laptop,
    // a mouse is connected or disconnected, etc).
    const mediaQuery = window.matchMedia("(pointer: coarse)");
    const handleMediaChange = (e) => setIsTouchDevice(e.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleMediaChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleMediaChange);
      }
    };
  }, []);

  return isTouchDevice;
};
